import "foundation-sites/js/foundation/foundation";
import "foundation-sites/js/foundation/foundation.dropdown";
import utils from "@bigcommerce/stencil-utils";
import { getCart } from "../../../../services/cart";
import { showAlertModal } from "./modal";
import {
  isSpendLimitExceeded,
  showSpendLimitExceededModal,
  injectBlockerElement,
} from "../common/utils/spend-limit";

export const CartPreviewEvents = {
  close: "closed.fndtn.dropdown",
  open: "opened.fndtn.dropdown",
};

const SINGLE_LINE_BUTTON_TEXT_LENGTH = 48;

export default function (secureBaseUrl, cartId) {
  const loadingClass = "is-loading";
  const $cart = $("[data-cart-preview]");
  const $cartDropdown = $("#cart-preview-dropdown");
  const $cartLoading = $('<div class="loadingOverlay"></div>');
  const $body = $("body");

  showPaymentDisclaimerText();

  if (window.ApplePaySession) {
    $cartDropdown.addClass("apple-pay-supported");
  }

  $body.on("cart-quantity-update", (event, quantity) => {
    $cart.attr("aria-label", (_, prevValue) =>
      prevValue.replace(/\d+/, quantity)
    );

    if (!quantity) {
      $cart.addClass("navUser-item--cart__hidden-s");
    } else {
      $cart.removeClass("navUser-item--cart__hidden-s");
    }

    $(".cart-quantity")
      .text(quantity)
      .toggleClass("countPill--positive", quantity > 0);
    if (utils.tools.storage.localStorageAvailable()) {
      localStorage.setItem("cart-quantity", quantity);
    }
  });

  $cart.on("click", (event) => {
    const options = {
      template: "common/cart-preview",
    };

    // Redirect to full cart page
    //
    // https://developer.mozilla.org/en-US/docs/Browser_detection_using_the_user_agent
    // In summary, we recommend looking for the string 'Mobi' anywhere in the User Agent to detect a mobile device.
    if (/Mobi/i.test(navigator.userAgent)) {
      return event.stopPropagation();
    }

    event.preventDefault();

    $cartDropdown.addClass(loadingClass).html($cartLoading);
    $cartLoading.show();

    utils.api.cart.getContent(options, async (err, response) => {
      $cartDropdown.removeClass(loadingClass).html(response);
      $cartLoading.hide();

      const cartData = await getCart();

      $("[data-cart-preview-checkout-button]")
        .off("click")
        .on("click", async (event) => {
          event.preventDefault();

          const buttonHref = event.currentTarget.getAttribute("href");
          const spendLimitExceeded = isSpendLimitExceeded(
            window.jsContext.maxTotalOrderSpendConfig,
            cartData
          );

          if (spendLimitExceeded) {
            showSpendLimitExceededModal(
              window.jsContext.maxTotalOrderSpendConfig,
              window.jsContext.maxTotalOrderSpendTranslationsJSON,
              showAlertModal
            );
            return;
          }

          window.location.assign(buttonHref);
        });

      const $additionalCheckoutButtonsContainer = $(
        ".previewCart-additionalCheckoutButtons"
      );

      if ($additionalCheckoutButtonsContainer.length > 0) {
        const spendLimitExceeded = isSpendLimitExceeded(
          window.jsContext.maxTotalOrderSpendConfig,
          cartData
        );

        if (spendLimitExceeded) {
          injectBlockerElement($additionalCheckoutButtonsContainer, (event) => {
            showSpendLimitExceededModal(
              window.jsContext.maxTotalOrderSpendConfig,
              window.jsContext.maxTotalOrderSpendTranslationsJSON,
              showAlertModal
            );
          });
          return;
        }

        $additionalCheckoutButtonsContainer
          .find("[data-additional-checkout-buttons-blocker]")
          .remove();
      }
      resizeCartActionButtons();
    });
  });

  let quantity = 0;

  if (cartId) {
    // Get existing quantity from localStorage if found
    if (utils.tools.storage.localStorageAvailable()) {
      if (localStorage.getItem("cart-quantity")) {
        quantity = Number(localStorage.getItem("cart-quantity"));
        $body.trigger("cart-quantity-update", quantity);
      }
    }

    // Get updated cart quantity from the Cart API
    const cartQtyPromise = new Promise((resolve, reject) => {
      utils.api.cart.getCartQuantity(
        { baseUrl: secureBaseUrl, cartId },
        (err, qty) => {
          if (err) {
            // If this appears to be a 404 for the cart ID, set cart quantity to 0
            if (err === "Not Found") {
              resolve(0);
            } else {
              reject(err);
            }
          }
          resolve(qty);
        }
      );
    });

    // If the Cart API gives us a different quantity number, update it
    cartQtyPromise.then((qty) => {
      quantity = qty;
      $body.trigger("cart-quantity-update", quantity);
    });
  } else {
    $body.trigger("cart-quantity-update", quantity);
  }
}

// Stack cart drawer buttons such that each occupy 1 line in length,
// if text is too long and would span different heights otherwise
export function resizeCartActionButtons() {
  const $viewCartButton = $(".previewCartAction-viewCart")
    .first()
    .children()
    .first();

  const $checkoutButton = $(".previewCartAction-checkout")
    .first()
    .children()
    .first();

  const $buttonsContainer = $(".previewCartAction");
  if (!$viewCartButton[0] || !$checkoutButton[0] || !$buttonsContainer[0])
    return;
  const viewCartButtonHeight =
    $viewCartButton[0].getBoundingClientRect().height;
  const checkoutButtonHeight =
    $checkoutButton[0].getBoundingClientRect().height;
  if (
    viewCartButtonHeight > SINGLE_LINE_BUTTON_TEXT_LENGTH ||
    checkoutButtonHeight > SINGLE_LINE_BUTTON_TEXT_LENGTH
  ) {
    const targetButtonWidth =
      $buttonsContainer[0].getBoundingClientRect().width;
    $viewCartButton.css({
      width: `${targetButtonWidth}px`,
      marginBottom: "10px",
    });
    $checkoutButton.css({
      width: `${targetButtonWidth}px`,
      marginLeft: "-5px",
    });
    $buttonsContainer.css({
      display: "flex",
      flexDirection: "column",
    });
  }
}

function showPaymentDisclaimerText() {
  // Only run if we have a disclaimer text to show
  if (!window.themeSettings?.payment_disclaimer_text) return;
  const siblingElementSelector = ".previewCart-additionalCheckoutButtons";
  const disclaimerElementId = "payment-disclaimer-text-cart-preview";
  const cartPreviewDropdownElement = document.getElementById(
    "cart-preview-dropdown"
  );
  const cartPreviewDropdownObserver = new MutationObserver(
    (mutations, observer) => {
      const siblingElement = cartPreviewDropdownElement.querySelector(
        siblingElementSelector
      );
      if (!siblingElement) return; // sibling element not found, so no need to show disclaimer text yet
      const disclaimerElement = document.querySelector(
        `#${disclaimerElementId}`
      );
      if (disclaimerElement) return; // disclaimer element already exists, don't add it again
      const div = document.createElement("div");
      div.id = disclaimerElementId;
      div.className = "payment-disclaimer-text";
      div.style.marginTop = "2rem";
      div.style.marginBottom = "0rem";
      div.innerHTML = `
    <div class="info-icon-container">
      <img class="info-icon" src="https://imagedelivery.net/C0Y-4nEEMc16-K7sKznE7w/889cf008-2d08-4d3d-48de-3b7ad1778100/public" />
    </div>
    <div>
      <p>${window.themeSettings.payment_disclaimer_text}</p>
    </div>
    `;
      siblingElement.parentElement.insertBefore(div, siblingElement);
      observer.disconnect();
    }
  );
  cartPreviewDropdownObserver.observe(cartPreviewDropdownElement, {
    childList: true,
    subtree: true,
  });
}
